// extracted by mini-css-extract-plugin
export var layoutContainer = "_8p-0";
export var layoutContainerNoRounding = "_8p-6";
export var layoutContainerOpen = "_8p-5";
export var layoutContainerResizing = "_8p-1";
export var mainContent = "_8p-2";
export var resizeDivider = "_8p-3";
export var slidePanel = "_8p-4";